import React, { useCallback, useEffect } from 'react';

import { WarnModal } from '@/components/elements';
import { useAuthorization } from '@/modules/user/hooks';

interface Props {
  onSetVisible: (value: boolean) => void;
}

const ChangePasswordSuccessModal: React.FC<Props> = ({ onSetVisible }) => {
  const { handleLogout } = useAuthorization();

  const handleSubmit = useCallback(() => {
    onSetVisible(false);
    handleLogout();
  }, [onSetVisible, handleLogout]);

  useEffect(() => {
    return () => {
      handleSubmit();
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <WarnModal
      testId="password-successfully-changed"
      visible
      isSuccessIcon
      onSetVisible={onSetVisible}
      header="Password Was Successfully Changed"
      submitButtonText="Go Back to Sign In"
      onSubmit={handleSubmit}
    />
  );
};

export default ChangePasswordSuccessModal;
